import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { formatNumber } from '@angular/common';
import { UntypedFormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { startWith, pairwise } from 'rxjs/operators';

@Component({
  selector: 'mapfre-auditlib-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input()
  label

  @Input()
  label_tree

  @Input()
  placeholder

  @Input()
  inline

  @Input()
  maxlength = null

  @Input()
  maxValue = null

  @Input()
  minValue = null

  _type = 'text';
  @Input()
  get type() {
    return this._type;
  }

  set type(value) {
    if (value) {
      this._type = value;
    }
  }

  @Input()
  noValidations:boolean = false;

  _form;
  @Input()
  get form() {
    return this._form
  }
  set form(value) {
    if (value) {
      this._form = value;
    if(!this.noValidations){
      if (this._form.validator) {
        if (this._type === 'number') {
          this._form.setValidators([this._form.validator, this.validateDecimalsAndNumber]);
        }
        else {
          if (this.maxlength) {
            this._form.setValidators([Validators.maxLength(Number(this.maxlength)), this._form.validator]);
          }
          else {
            this._form.setValidators([this._form.validator]);
          }
        }
      }
      else {
        if (this._type === 'number') {
          this._form.setValidators([this.validateDecimalsAndNumber]);
          if (this.maxValue) {
            this._form.setValidators([Validators.max(Number(this.maxValue)), this._form.validator]);
          }
        }
        else {
          if (this.maxlength) {
            this._form.setValidators([Validators.maxLength(Number(this.maxlength))]);
          }         
        }
      }
    }
   }
  }


  _model;
  @Input()
  get model() {
    return this._model
  }
  set model(value) {
    this._model = value;
    this.form = new UntypedFormControl(this._model);
    // this.modelChange.emit(this._model); No es necesario que emita una actualización cuando se carga por primera vez. Esto solo se ejecuta al hacer la carga del HTML ya que para el resto de cambios se usa el metodo al final de esta clase.
  }


  @Input() icon;

  @Input() styleClass;

  @Input() skipHighlighter = false;



  @Input() readonly;
  @Output()
  modelChange = new EventEmitter();

  @Input()
  buttonIcon;
  @Output()
  buttonClicked = new EventEmitter();

  @Output()
  blur = new EventEmitter();

  @ViewChild("inputRef", { static: false })
  private inputRef: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  @HostListener('keydown.enter', ['$event'])
  onButtonClicked() {
    this.buttonClicked.emit();
    if (this.form) {
      this.form.markAsTouched();
    }
    this.onBlurHandler();
  }

  onBlurHandler() {
    this.blur.emit(this.form);
  }

  countCharInString(str, ch) {
    return _.countBy(str)[ch] || 0
  }

  validateDecimalsAndNumber = (control: UntypedFormControl): { [input: string]: boolean } => {

    let isValidDecimals = true;

    //If it's string return null (only validate number)
    if (_.isNaN(Number(control.value))) {
      return null;
    }

    if (control.value) {
      const hasMoreThanTwoDecimals = control.value.toString().split('.').length > 1 ? control.value.toString().split('.')[1].length > 2 : false;
      if (hasMoreThanTwoDecimals) {
        isValidDecimals = false;
      }
    } else if (control.value === '') {
      return { validateNumberFormat: true };
    }

    if (isValidDecimals === false && control.value !== null && control.value !== '' && control.value !== undefined) {
      return { validateMaxTwoDecimals: true };
    }
    else if (isValidDecimals === true) {
      return null;
    }
  }

  focus() {
    this.inputRef.nativeElement.focus();
    this.inputRef.nativeElement.click();
  }

  setModel(event) {
    this.form.updateValueAndValidity();
    this._model = event.target.value;
    this.modelChange.emit(event.target.value);
  }

}
